//import React from 'react';

import React, { useState, useEffect } from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Checkbox from "@material-ui/core/Checkbox";

import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import IconButton from "@material-ui/core/IconButton";
import ShareIcon from "@material-ui/icons/ShareTwoTone";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import Grid from "@material-ui/core/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormLabel from "@material-ui/core/FormLabel";


import Slider from '@material-ui/core/Slider';
import Typography from '@material-ui/core/Typography';

import { getDefaultVoices } from "../shared/Voices";
var count = 0;

export default function SettingsDialog(props) {
  var G_german_voice;
  var G_english_voice;
  var G_spanish_voice;
  var G_french_voice;
  var G_italian_voice;

  // var found_voices = getDefaultVoices();
  // G_spanish_voice = found_voices.G_spanish_voice;
  // G_german_voice = found_voices.G_german_voice;
  // G_english_voice = found_voices.G_english_voice;
  // G_french_voice = found_voices.G_french_voice;
  // G_italian_voice = found_voices.G_italian_voice;

  var voices = speechSynthesis.getVoices();
  //console.log(voices);
  var voice_names = [];

  voices.forEach(function(voice, i) {
    voice_names.push(voice.name);
  });

  voices = speechSynthesis.getVoices().filter(voice => /fr/.test(voice.lang));
  //console.log(voices);
  var french_voices = [];
  voices.forEach(function(voice, i) {
    french_voices.push(voice.name);
  });

  const [open, setOpen] = React.useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleSaveClose() {
    // alert(state.Speed);
    // return;
    props.handleSettingsChanged(
      state.Right,
      state.Left,
      state.Up,
      state.Down,
      state.SpanishVoice,
      state.GermanVoice,
      state.EnglishVoice,
      state.FrenchVoice,
      state.ItalianVoice,
      state.X,
      state.Y,
      state.A,
      state.B,
      state.Start,
      state.Select,
      state.Speed
    );
    setOpen(false);
  }

  function handleClose() {
    setOpen(false);
  }

  const [state, setState] = React.useState({
    // Present: false,
    // Past: false,
    // Past1: false,
    // Future: false,
    // Conditional: false,
    // Imperativ:false,
    // Imperativ1:false,
    Languages: [
      "Language1",
      "Language2",
      "Language3",
      "Language4",
      "Language5",
      "Description1",
      "Description2",
      "Description3",
      "Description4",
      "Description5"
    ],
    Right: "",
    Left: "Language1",
    Up: "Language2",
    Down: "Language1",
    X: "Description1",
    Y: "Description2",
    A: "Description1",
    B: "Description2",
    Start: "Language1",
    Select: "Language4",
    SpanishVoice: "",
    GermanVoice: "",
    EnglishVoice: "",
    FrenchVoice: "",
    ItalianVoice: "",
    Voices: voice_names,
    LanguageUsed: "Spanish",
    FrenchVoices: french_voices,
    Speed:2
  });

  const handleChange = name => event => {
    setState({ ...state, [name]: event.target.checked });
  };

  const handleChangeslider = (event, newValue) => {
    console.log(newValue );
    setState({ ...state, ["Speed"]: newValue });
  };

  const handleChangeSelect = name => event => {
    if (name == "LanguageUsed") {
      if (event.target.value == "Spanish") {
        setState({
          ...state,
          [name]: event.target.value,
          ["Right"]: "Language1",
          ["Left"]: "Language1",
          ["Down"]: "Language1",
          ["Up"]: "Language2",
          ["X"]: "Description1",
          ["Y"]: "Description2"
        });
      }
      if (event.target.value == "German") {
        setState({
          ...state,
          [name]: event.target.value,
          ["Right"]: "Language2",
          ["Left"]: "Language2",
          ["Down"]: "Language2",
          ["Up"]: "Language1",
          ["X"]: "Description2",
          ["Y"]: "Description1"
        });
      }
      if (event.target.value == "French") {
        setState({
          ...state,
          [name]: event.target.value,
          ["Right"]: "Language4",
          ["Left"]: "Language4",
          ["Down"]: "Language4",
          ["Up"]: "Language3",
          ["X"]: "Description4",
          ["Y"]: "Description3"
        });
      }
      if (event.target.value == "English->French") {
        setState({
          ...state,
          [name]: event.target.value,
          ["Right"]: "Language3",
          ["Left"]: "Language3",
          ["Down"]: "Language3",
          ["Up"]: "Language4",
          ["X"]: "Description3",
          ["Y"]: "Description4"
        });
      }
    } else {
      setState({ ...state, [name]: event.target.value });
    }
  };

  useEffect(() => {
    if (count < 1) {
      setState({ ...state, ["FrenchVoices"]: french_voices });
      //console.log(count);

      setState({ ...state, ["Voices"]: voice_names });
      //alert(props.settingSpeak.SpanishVoice );

      //console.log(props.settingSpeak.SpanishVoice);
    //  if (state.Right == "" || state.GermanRightVoice == undefined) {
      if (state.Right == "" ) {
      //  alert(props.settingSpeak.Speed);
        setState({
          ...state,
          ["Right"]: props.settingSpeak.Right,
          ["Left"]: props.settingSpeak.Left,
          ["Up"]: props.settingSpeak.Up,
          ["Down"]: props.settingSpeak.Down,
          ["X"]: props.settingSpeak.X,
          ["Y"]: props.settingSpeak.Y,
          ["A"]: props.settingSpeak.A,
          ["B"]: props.settingSpeak.B,
          ["Start"]: props.settingSpeak.Start,
          ["Select"]: props.settingSpeak.Select,
         ["Speed"]:props.settingSpeak.Speed
        });
      }
      if (state.Right.length > 0) count++;

      if (state.GermanVoice == "" || state.GermanVoice == undefined) {
        setState({ ...state, ["GermanVoice"]: props.settingSpeak.GermanVoice });
      }
      if (state.EnglishVoice == "" || state.EnglishVoice == undefined) {
        setState({
          ...state,
          ["EnglishVoice"]: props.settingSpeak.EnglishVoice
        });
      }
      if (state.SpanishVoice == "" || state.SpanishVoice == undefined) {
        setState({
          ...state,
          ["SpanishVoice"]: props.settingSpeak.SpanishVoice
        });
      }
      if (state.FrenchVoice == "" || state.FrenchVoice == undefined) {
        setState({ ...state, ["FrenchVoice"]: props.settingSpeak.FrenchVoice });
      }
      if (state.ItalianVoice == "" || state.ItalianVoice == undefined) {
        setState({
          ...state,
          ["ItalianVoice"]: props.settingSpeak.ItalianVoice
        });
      }
    }
  });

  //voices = speechSynthesis.getVoices();
  //setState({ ...state, ["Voices"]: voices });

  // useEffect(() => {
  // if(state.Voices.length<2)
  // {

  //   setState({ ...state, ["Voices"]: voice_names });
  //   if(state.GermanVoice=="")
  //   {
  //     if(G_german_voice != undefined && G_german_voice!="")
  //     {
  //       setState({ ...state, ["GermanVoice"]: G_german_voice });
  //     }
  //   }
  //   if(state.EnglishVoice=="")
  //   {
  //     if(G_english_voice != undefined && G_english_voice!="")
  //     {
  //       setState({ ...state, ["EnglishVoice"]: G_english_voice });
  //     }
  //   }
  //   if(state.SpanishVoice=="")
  //   {
  //     if(G_spanish_voice != undefined && G_spanish_voice!="")
  //     {
  //       setState({ ...state, ["SpanishVoice"]: G_spanish_voice });
  //     }
  //   }
  //   if(state.FrenchVoice=="")
  //   {
  //     if(G_french_voice != undefined && G_french_voice!="")
  //     {
  //       setState({ ...state, ["FrenchVoice"]: G_french_voice });
  //     }
  //   }
  // }

  // });

  //console.log(state.Voices);
  //console.log(voices);

  return (
    <div>
      <IconButton aria-label="Share" onClick={handleClickOpen}>
        <ShareIcon />
      </IconButton>

      <Dialog
        fullWidth="sm"
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Settings"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Edit settings
          </DialogContentText>

          <FormControl component="fieldset" className="">
            <FormLabel component="legend">Languages</FormLabel>
            <RadioGroup
              aria-label="gender"
              name="LanguageUsed"
              className=""
              value={state.LanguageUsed}
              onChange={handleChangeSelect("LanguageUsed")}
              row
            >
              <FormControlLabel
                value="Spanish"
                control={<Radio />}
                label="Spanish"
              />
              <FormControlLabel
                value="German"
                control={<Radio />}
                label="German"
              />
              <FormControlLabel
                value="French"
                control={<Radio />}
                label="French"
              />
              <FormControlLabel
                value="English->French"
                control={<Radio />}
                label="French->English"
              />
            </RadioGroup>
          </FormControl>

          <Grid container spacing={1}>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel htmlFor="Right">Right</InputLabel>
                <Select
                  value={state.Right}
                  onChange={handleChangeSelect("Right")}
                  inputProps={{
                    name: "Right",
                    id: "name-simple"
                  }}
                >
                  {typeof state.Languages != "undefined" &&
                    state.Languages.map(se => (
                      <MenuItem value={se}>{se}</MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel htmlFor="Left">Left</InputLabel>
                <Select
                  value={state.Left}
                  onChange={handleChangeSelect("Left")}
                  inputProps={{
                    name: "Left",
                    id: "name-simple"
                  }}
                >
                  {typeof state.Languages != "undefined" &&
                    state.Languages.map(se => (
                      <MenuItem value={se}>{se}</MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel htmlFor="Up">Up</InputLabel>
                <Select
                  value={state.Up}
                  onChange={handleChangeSelect("Up")}
                  inputProps={{
                    name: "Up",
                    id: "name-simple"
                  }}
                >
                  {typeof state.Languages != "undefined" &&
                    state.Languages.map(se => (
                      <MenuItem value={se}>{se}</MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel htmlFor="Down">Down</InputLabel>
                <Select
                  value={state.Down}
                  onChange={handleChangeSelect("Down")}
                  inputProps={{
                    name: "Down",
                    id: "name-simple"
                  }}
                >
                  {typeof state.Languages != "undefined" &&
                    state.Languages.map(se => (
                      <MenuItem value={se}>{se}</MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel htmlFor="X">X</InputLabel>
                <Select
                  value={state.X}
                  onChange={handleChangeSelect("X")}
                  inputProps={{
                    name: "X",
                    id: "name-simple"
                  }}
                >
                  {typeof state.Languages != "undefined" &&
                    state.Languages.map(se => (
                      <MenuItem value={se}>{se}</MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel htmlFor="Y">Y</InputLabel>
                <Select
                  value={state.Y}
                  onChange={handleChangeSelect("Y")}
                  inputProps={{
                    name: "Y",
                    id: "name-simple"
                  }}
                >
                  {typeof state.Languages != "undefined" &&
                    state.Languages.map(se => (
                      <MenuItem value={se}>{se}</MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel htmlFor="A">A</InputLabel>
                <Select
                  value={state.A}
                  onChange={handleChangeSelect("A")}
                  inputProps={{
                    name: "A",
                    id: "name-simple"
                  }}
                >
                  {typeof state.Languages != "undefined" &&
                    state.Languages.map(se => (
                      <MenuItem value={se}>{se}</MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel htmlFor="B">B</InputLabel>
                <Select
                  value={state.B}
                  onChange={handleChangeSelect("B")}
                  inputProps={{
                    name: "B",
                    id: "name-simple"
                  }}
                >
                  {typeof state.Languages != "undefined" &&
                    state.Languages.map(se => (
                      <MenuItem value={se}>{se}</MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>



          <Grid container spacing={1}>

            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel htmlFor="Select">Select</InputLabel>
                <Select
                  value={state.Select}
                  onChange={handleChangeSelect("Select")}
                  inputProps={{
                    name: "Select",
                    id: "name-simple"
                  }}
                >
                  {typeof state.Languages != "undefined" &&
                    state.Languages.map(se => (
                      <MenuItem value={se}>{se}</MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel htmlFor="Start">Start</InputLabel>
                <Select
                  value={state.Start}
                  onChange={handleChangeSelect("Start")}
                  inputProps={{
                    name: "Start",
                    id: "name-simple"
                  }}
                >
                  {typeof state.Languages != "undefined" &&
                    state.Languages.map(se => (
                      <MenuItem value={se}>{se}</MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>

          </Grid>











          <br></br>
          <FormControl fullWidth>
            <InputLabel htmlFor="SpanishVoice">SpanishVoice</InputLabel>
            <Select
              value={state.SpanishVoice}
              onChange={handleChangeSelect("SpanishVoice")}
              inputProps={{
                name: "SpanishVoice",
                id: "name-simple"
              }}
            >
              {typeof state.Voices != "undefined" &&
                state.Voices.map(se => <MenuItem value={se}>{se}</MenuItem>)}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel htmlFor="GermanVoice">GermanVoice</InputLabel>
            <Select
              value={state.GermanVoice}
              onChange={handleChangeSelect("GermanVoice")}
              inputProps={{
                name: "GermanVoice",
                id: "name-simple"
              }}
            >
              {typeof state.Voices != "undefined" &&
                state.Voices.map(se => <MenuItem value={se}>{se}</MenuItem>)}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel htmlFor="EnglishVoice">EnglishVoice</InputLabel>
            <Select
              value={state.EnglishVoice}
              onChange={handleChangeSelect("EnglishVoice")}
              inputProps={{
                name: "EnglishVoice",
                id: "name-simple"
              }}
            >
              {typeof state.Voices != "undefined" &&
                state.Voices.map(se => <MenuItem value={se}>{se}</MenuItem>)}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel htmlFor="FrenchVoice">FrenchVoice</InputLabel>
            <Select
              value={state.FrenchVoice}
              onChange={handleChangeSelect("FrenchVoice")}
              inputProps={{
                name: "FrenchVoice",
                id: "name-simple"
              }}
            >
              {typeof state.FrenchVoices != "undefined" &&
                state.FrenchVoices.map(se => (
                  <MenuItem value={se}>{se}</MenuItem>
                ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel htmlFor="ItalianVoice">ItalianVoice</InputLabel>
            <Select
              value={state.ItalianVoice}
              onChange={handleChangeSelect("ItalianVoice")}
              inputProps={{
                name: "ItalianVoice",
                id: "name-simple"
              }}
            >
              {typeof state.Voices != "undefined" &&
                state.Voices.map(se => <MenuItem value={se}>{se}</MenuItem>)}
            </Select>
          </FormControl>

<br></br>
<br></br>
      <Typography id="discrete-slider" gutterBottom>
        Speed
      </Typography>
          <Slider
        value={state.Speed}
        aria-labelledby="discrete-slider"
        valueLabelDisplay="auto"
        step={0.5}
        marks
        min={1}
        max={5}
        onChange={handleChangeslider}
      />

          {/* <FormControlLabel
            control={
            <Checkbox checked={state.Imperativ1} onChange={handleChange('Imperativ1')} value="Imperativ1" />
            }
            label="Imperativ1"
        /> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Disagree
          </Button>
          <Button onClick={handleSaveClose} color="primary" autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
